import React from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { frontloadConnect } from "react-frontload";
import { getTrainingLink } from "../actions";

const frontload = async (props) => {
  await props.getTrainingLink();
};

const mapStateToProps = (state) => {
  return {
    trainingUrl: state.training.trainingUrl,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getTrainingLink: (...args) => dispatch(getTrainingLink(...args)),
});

const UserTrainingLink = ({ className = "nav", trainingUrl }) => {
  return (
    <a
      className={className}
      target="_blank"
      href="https://www.technik-campus.de"
    >
      Schulung
    </a>
  );
};

UserTrainingLink.propTypes = {
  className: PropTypes.string,
  trainingUrl: PropTypes.string,
};

UserTrainingLink.defaultProps = {
  className: "nav",
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  frontloadConnect(frontload, {
    onMount: true,
    onUpdate: false,
  })(UserTrainingLink),
);
